// extracted by css-extract-rspack-plugin
export default {"root":"qZlLi","leftAligned":"lzE3r","rightAligned":"_CN4y","centerAligned":"VSM9c"};